import {PrintBatchComponent} from './print-batch/print-batch.component';
import {ModalUninvoicedShipmentsComponent} from './resources/modal-uninvoiced-shipments/modal-uninvoiced-shipments.component';
import {ModalUninvoicedWorkordersComponent} from './resources/modal-uninvoiced-workorders/modal-uninvoiced-workorders.component';
import {ModalUninvoicedQuotesComponent} from './resources/modal-uninvoiced-quotes/modal-uninvoiced-quotes.component';
import {PaymentFormComponent} from './payment-form/payment-form.component';
import {PaymentPrintComponent} from './payment-print/payment-print.component';
import {ModalSelectItemComponent} from './resources/modal-select-item/modal-select-item.component';
import {ModalSelectSalespersonComponent} from './resources/modal-select-salesperson/modal-select-salesperson.component';
import {ModalNewAccountComponent} from './resources/modal-new-account/modal-new-account.component';
import {ModalNewItemComponent} from './resources/modal-new-item/modal-new-item.component';
import {ModalNewAddressComponent} from './resources/modal-new-address/modal-new-address.component';
import {ModalNewContactComponent} from './resources/modal-new-contact/modal-new-contact.component';
import {ModalSelectEntityComponent} from './resources/modal-select-entity/modal-select-entity.component';
import {ModalNewEntityComponent} from './resources/modal-new-entity/modal-new-entity.component';
import {ModalEntityHistoryComponent} from './resources/modal-entity-history/modal-entity-history.component';
import {ModalSignatureComponent} from './resources/modal-signature/modal-signature.component';
import {InvoiceEmailComponent} from './invoice-email/invoice-email.component';
import {InvoicePrintComponent} from './invoice-print/invoice-print.component';
import {InvoiceRecurringListComponent} from './invoice-recurring-list/invoice-recurring-list.component';
import {AlertComponent} from './resources/alert/alert.component';
import {PaymentEmailComponent} from './payment-email/payment-email.component';
import {CommonModule, DatePipe, DecimalPipe, CurrencyPipe, NgOptimizedImage} from '@angular/common';
import {SharedModule} from '../common/shared.module';
import {NgModule} from '@angular/core';
import {FilterPipeModule} from 'ngx-filter-pipe';
import {ModalInsertItemComponent} from './resources/modal-insert-item/modal-insert-item.component';
import {PaymentListComponent} from './payment-list/payment-list.component';
import {IssuePaymentsComponent} from './issue-payments/issue-payments.component';
import {InvoiceListArComponent} from './invoice-list-ar/invoice-list-ar.component';
import {InvoiceListApComponent} from './invoice-list-ap/invoice-list-ap.component';
import {BankReconciliationListComponent} from '../bank/bank-reconciliation/bank-reconciliation-list/bank-reconciliation-list.component';
import {StatisticalRecurringListComponent} from './statistical-recurring-list/statistical-recurring-list.component';
import {BankReconciliationFormComponent} from '../bank/bank-reconciliation/bank-reconciliation-form/bank-reconciliation-form.component';
import {BankImportWizardComponent} from '../bank/bank-import/bank-import-wizard/bank-import-wizard.component';
import {BankImportHistoryComponent} from '../bank/bank-import/bank-import-history/bank-import-history.component';
import {BankImportIgnoreRulesComponent} from '../bank/bank-import/bank-import-ignore-rules/bank-import-ignore-rules.component';
import {BankImportPageComponent} from '../bank/bank-import/bank-import-page/bank-import-page.component';
import {EntryFormComponent} from './entry-form/entry-form.component';
import {GlImportComponent} from './gl-import/gl-import.component';
import {EntryListComponent} from './entry-list/entry-list.component';
import {EntryRecurringComponent} from './entry-recurring/entry-recurring.component';
import {StatisticalListComponent} from './statistical-list/statistical-list.component';
import {StatisticalFormComponent} from './statistical-form/statistical-form.component';
import {DecimalNewPipe} from '../common/DecimalNewPipe';
import {AdminModule} from '../admin/admin.module';
import {ModalItemsToOrderComponent} from './resources/modal-items-to-order/modal-items-to-order.component';
import {ShipmentListComponent} from './shipment-list/shipment-list.component';
import {ShipmentPrintComponent} from './shipment-print/shipment-print.component';
import { ShipmentFormComponent } from './shipment-form/shipment-form.component';
import {ReactiveFormsModule} from '@angular/forms';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbPaginationModule,
} from '@ng-bootstrap/ng-bootstrap';
import { PrintTransactionDocument } from './print-transaction-document/print-transaction-document';
import {WidgetModule} from '../common/widget/widget.module';
import {ComponentsModule} from '../components.module';
// Type-specific wrappers and action components for Invoice Form
import {InvoiceFormArComponent} from './invoice-form-ar/invoice-form-ar.component';
import {InvoiceFormApComponent} from './invoice-form-ap/invoice-form-ap.component';
import {InvoiceFormSoComponent} from './invoice-form-so/invoice-form-so.component';
import {InvoiceListSoComponent} from './invoice-list-so/invoice-list-so.component';
import {InvoiceFormPoComponent} from './invoice-form-po/invoice-form-po.component';
import {InvoiceListPoComponent} from './invoice-list-po/invoice-list-po.component';
import {InvoiceFormQuotePageComponent} from './invoice-form-quote/invoice-form-quote.component';
import {InvoiceListQuoteComponent} from './invoice-list-quote/invoice-list-quote.component';
import {InvoiceFormSoPoComponent} from './invoice-form-shared/types/invoice-form-so-po.component';
import {InvoiceFormQuoteComponent} from './invoice-form-shared/types/invoice-form-quote.component';
import {InvoiceFormArApComponent} from './invoice-form-shared/types/invoice-form-ar-ap.component';
import {InvoiceActionsSoPoComponent} from './invoice-form-shared/actions/invoice-actions-so-po.component';
import {InvoiceActionsQuoteComponent} from './invoice-form-shared/actions/invoice-actions-quote.component';
import {ReportingFieldsComponent} from './resources/reporting-fields/reporting-fields.component';
import {TransactionTotalsComponent} from './resources/transaction-totals/transaction-totals.component';
import {
  ReportDatepickerAdapter,
  ReportDatepickerFormatService,
  ReportDatepickerParserFormatter,
} from '../common/ngb-datepicker/ngb-datepicker-adapter';


@NgModule({
  declarations: [
    PrintBatchComponent,
    ModalUninvoicedShipmentsComponent,
    ModalUninvoicedWorkordersComponent,
    ModalUninvoicedQuotesComponent,
    PaymentFormComponent,
    PaymentPrintComponent,
    PaymentEmailComponent,
    AlertComponent,
    ModalSelectItemComponent,
    ModalSelectSalespersonComponent,
    ModalNewAccountComponent,
    ModalNewItemComponent,
    ModalNewAddressComponent,
    ModalNewContactComponent,
    ModalSelectEntityComponent,
    ModalNewEntityComponent,
    ModalEntityHistoryComponent,
    ModalSignatureComponent,
    InvoiceEmailComponent,
    InvoicePrintComponent,
    InvoiceRecurringListComponent,
    ModalInsertItemComponent,
    PaymentListComponent,
    IssuePaymentsComponent,
    InvoiceListArComponent,
    InvoiceListApComponent,
    InvoiceListSoComponent,
    InvoiceListPoComponent,
    InvoiceListQuoteComponent,
    InvoiceFormQuotePageComponent,
    BankReconciliationListComponent,
    StatisticalRecurringListComponent,
    BankReconciliationFormComponent,
    BankImportWizardComponent,
    BankImportHistoryComponent,
    BankImportIgnoreRulesComponent,
    BankImportPageComponent,
    EntryFormComponent,
    EntryListComponent,
    GlImportComponent,
    EntryRecurringComponent,
    StatisticalListComponent,
    StatisticalFormComponent,
    ModalItemsToOrderComponent,
    ShipmentListComponent,
    ShipmentPrintComponent,
    ShipmentFormComponent,
    PrintTransactionDocument,
    // Invoice form type wrappers
    InvoiceFormArComponent,
    InvoiceFormApComponent,
    InvoiceFormSoComponent,
    InvoiceFormPoComponent,
    InvoiceFormSoPoComponent,
    InvoiceFormQuoteComponent,
    InvoiceFormArApComponent,
    // Presentational action sections
    InvoiceActionsSoPoComponent,
    InvoiceActionsQuoteComponent,
    // Shared transaction form sub-components
    ReportingFieldsComponent,
    TransactionTotalsComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FilterPipeModule,
    AdminModule,
    ReactiveFormsModule,
    NgbPaginationModule,
    NgbDropdownModule,
    WidgetModule,
    ComponentsModule,
    NgbDatepickerModule,
    NgOptimizedImage,
  ],
  exports: [
    ModalSelectEntityComponent,
    ModalInsertItemComponent,
    ModalSelectItemComponent,
    ModalSignatureComponent,
    ModalEntityHistoryComponent,
    ModalItemsToOrderComponent,
    InvoicePrintComponent,
  ],
  providers: [
    DatePipe,
    DecimalPipe,
    DecimalNewPipe,
    CurrencyPipe,
    ReportDatepickerFormatService,
    {
      provide: NgbDateParserFormatter,
      useClass: ReportDatepickerParserFormatter,
    },
    {
      provide: NgbDateAdapter,
      useFactory: (formatter: NgbDateParserFormatter) => new ReportDatepickerAdapter(formatter),
      deps: [NgbDateParserFormatter],
    },
  ],
})
export class TransactionsModule {}
